var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mark-count-num",style:({fontSize: _vm.fontSize + 'rpx',fontWeight: _vm.bold ? 'bold' : 'normal',color: _vm.color})},[_vm._v("\n    "+_vm._s(_vm.displayValue)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a68874","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mark-count-to/mark-count-to.vue
// module id = null
// module chunks = 